import React, { useRef } from "react";
import { Socials } from "../../components";
import { ReactComponent as SendIcon } from "../../assets/svgs/Send.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import { motion } from "framer-motion";

const contactMessageVariant = {
  hidden: {
    opacity: 0,
    transition: { when: "beforeChildren" },
  },
  show: {
    opacity: 1,
    transition: {
      duration: 3,
      staggerChildren: 1,
      delayChildren: 0.5,
    },
  },
};

const contactMessageTextVariant = {
  hidden: {
    opacity: 0,
    x: -10,
  },
  show: {
    opacity: 1,
    x: 0,
  },
};

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_emailjsServiceId,
        process.env.REACT_APP_emailjsTemplateId,
        form.current,
        process.env.REACT_APP_emailjsPublicKey
      )
      .then(
        (result) => {
          toast.success("Message delivered successfully!");
          form.current.reset();
        },
        (error) => {
          toast.error(error.text);
        }
      );
  };
  return (
    <div id="contact">
      <ToastContainer />
      <div className="flex">
        <motion.div
          variants={contactMessageVariant}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="t"
        >
          <motion.h1
            initial={{ opacity: 0, scale: 0.5 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 0.3,
              ease: [0, 0.71, 0.2, 1.01],
              scale: {
                type: "spring",
                damping: 5,
                stiffness: 100,
                restDelta: 0.001,
              },
            }}
          >
            Get In Touch
          </motion.h1>
          <motion.p variants={contactMessageTextVariant}>
            Want to reach out?
          </motion.p>
          <motion.p variants={contactMessageTextVariant}>
            Got a project in mind?
          </motion.p>
          <motion.p variants={contactMessageTextVariant}>
            Kindly fill out the form.
          </motion.p>
          <motion.p variants={contactMessageTextVariant}>
            I'd love to hear from you!
          </motion.p>
          <Socials />
        </motion.div>
        <motion.form
          initial={{ x: "40px", opacity: 0 }}
          transition={{ duration: 2 }}
          whileInView={{ opacity: 1, x: "0px" }}
          viewport={{ once: true }}
          ref={form}
          onSubmit={sendEmail}
        >
          <label htmlFor="name">Name</label>
          <input type="text" name="name" id="name" required />
          <label htmlFor="email">Email</label>
          <input type="email" name="email" id="email" required />
          <label htmlFor="messageTitle">Message Title</label>
          <input
            type="text"
            name="messageTitle"
            id="messageTitle"
            maxLength="2000"
            required
          />
          <label htmlFor="message">Message</label>
          <textarea
            name="message"
            id="message"
            cols="20"
            rows="6"
            maxLength="20000"
            required
          ></textarea>
          <button className="sendEmail" type="submit">
            <SendIcon className="sendIcon" /> SEND
          </button>
        </motion.form>
      </div>
    </div>
  );
};

export default Contact;
